/*
 * custom (Second Edition): pre-order PDP (templates/product.arriving-soon.json).
 * 1. Moves the render badge from its <template> into the main product's hero slider, bottom-left.
 *    The slider only treats .product-images__slide.is-active as cells, so the badge is not a slide.
 * Does nothing outside body.template-product-arriving-soon.
 */
(function () {
  function init() {
    var body = document.body;
    if (!body || !body.classList.contains('template-product-arriving-soon')) return;

    var tpl = document.getElementById('CustomPreorderPdpBadge');
    var slider = document.querySelector('.thb-product-detail .product-image-container .product-images');
    if (tpl && slider && !slider.querySelector('.custom-preorder-pdp-badge')) {
      slider.appendChild(tpl.content.cloneNode(true));
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
